import { cn } from '@/utils/cn';
import { ArrowUp, ArrowDown, Lock } from 'lucide-react';

type BalanceType = 'available' | 'pending' | 'blocked';

interface WalletBalanceCardProps {
  type: BalanceType;
  amount: number;
  className?: string;
}

const config: Record<BalanceType, { label: string; icon: React.ElementType; colorClass: string }> = {
  available: {
    label: 'Disponível',
    icon: ArrowUp,
    colorClass: 'text-green-600 bg-green-50 border-green-200',
  },
  pending: {
    label: 'Pendente',
    icon: ArrowDown,
    colorClass: 'text-yellow-600 bg-yellow-50 border-yellow-200',
  },
  blocked: {
    label: 'Bloqueado',
    icon: Lock,
    colorClass: 'text-red-600 bg-red-50 border-red-200',
  },
};

export function WalletBalanceCard({ type, amount, className }: WalletBalanceCardProps) {
  const { label, icon: Icon, colorClass } = config[type];

  const formatted = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(amount);

  return (
    <div
      className={cn(
        'bg-white rounded-xl border border-gray-200 p-4',
        className
      )}
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm text-gray-500">{label}</span>
        <div className={cn('p-1.5 rounded-lg border', colorClass)}>
          <Icon size={16} />
        </div>
      </div>
      <p className={cn('text-xl font-bold', type === 'available' && 'text-green-600')}>
        {formatted}
      </p>
    </div>
  );
}
